<script setup>
import { ref, defineProps } from "vue";
import InputPrice from "@/components/ui/InputPrice.vue";
import { emit as emitEvent } from "../../eventBus.js";
import Deposit from "@/models/Deposit.js";
import { Dialog, DialogScrollContent, DialogTrigger, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const { registration, baseFilters, defaultAmount } = defineProps({
  registration: {
    type: Object,
    default: () => null
  },
  baseFilters: {
    type: Object,
    default: () => null
  },
  currency: {
    type: String,
    default: null
  },
  defaultAmount: {
    type: Number,
    default: null
  },
});

const showModal = ref(false)
const amount = ref(defaultAmount);
const validationErrors = ref({})

const createDeposit = async () => {
  validationErrors.value = {};
  // Create deposit
  try {
    const depositModel = new Deposit({
      registration_id: registration.id,
      amount: amount.value,
      ...baseFilters
    });

    const deposit = await depositModel.save();

    showModal.value = false;
    emitEvent('deposit.created', deposit);
  } catch (error) {
    validationErrors.value = error.response.data.message;
  }
};

</script>
<template>
  <Dialog :open="showModal" @update:open="showModal = $event">
    <DialogTrigger class="btn btn-primary">
      {{ $t('Create a deposit request') }}
    </DialogTrigger>
    <DialogScrollContent>
      <DialogHeader>
        <DialogTitle>
          {{ $t(`Create Deposit for {name}`, { name: registration.name }) }}
        </DialogTitle>
      </DialogHeader>
      <div class="form-group">
        <label for="frm-deposit-amount">{{ $t('Amount') }}</label>
        <InputPrice
          id="frm-deposit-amount"
          :currency="currency"
          v-model="amount"
          :input-class="validationErrors.amount ? 'is-invalid' : ''"
        />
        <div class="invalid-feedback" v-if="validationErrors.amount">
          {{ validationErrors.amount[0] }}
        </div>
      </div>
      <DialogFooter>
        <button type="button" class="btn btn-primary" v-on:click.prevent="createDeposit()">{{ $t('Create deposit') }}</button>
      </DialogFooter>
    </DialogScrollContent>
  </Dialog>
</template>
